const transitionDurationMs = 100;
const wrapper = "_35sw1uj3stz";
const progress = "_35sp7u6otm";
const dimmed = "_35sd1e5xv0u";

export { dimmed, progress, transitionDurationMs, wrapper };
import "./atom.progress.style.linaria.module.css";
//# sourceMappingURL=atom.progress.style.js.map
